module.exports = __webpack_public_path__ + "img/class5.1366219a.png";